import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Button, Drawer, IconButton, Radio, RadioGroup, Stack, styled, Text } from 'shell/components';

const FilterDrawer = ({ filters, setFilters, resetFilters }) => {
    const { device } = useViewport();
    const { t } = useTranslation();

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    return (
        <Drawer
            anchor={'left'}
            device={device === 'desktop' ? 'tablet' : device}
            offsetForSidebar
            open={filters.open}
            onClose={onClose}
        >
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('controls.sort-by', 'Sort By')}
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        {t('controls.reset-all', 'Reset All')}
                    </Button>
                </Stack>
                <RadioGroup
                    aria-label={'sort by'}
                    value={filters.sort}
                    onChange={(_, value) => setFilters((current) => ({ ...current, sort: value }))}
                >
                    <CustomRadio
                        label={t('controls.sort-options.none', 'None')}
                        labelPlacement={'start'}
                        value={'none'}
                    />
                    <CustomRadio
                        label={t('controls.sort-options.title-asc', 'Title A-Z')}
                        labelPlacement={'start'}
                        value={'title-asc'}
                    />
                    <CustomRadio
                        label={t('controls.sort-options.title-desc', 'Title Z-A')}
                        labelPlacement={'start'}
                        value={'title-desc'}
                    />
                </RadioGroup>
            </Stack>
        </Drawer>
    );
};

const CustomRadio = styled(Radio)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

export default FilterDrawer;
